export default __webpack_public_path__ + "static/kaizen-31ff2a560f475e711259e1d36ffa45c0.svg";